import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=3967a404&scoped=true"
import script from "./UiIcon.vue?vue&type=script&lang=js"
export * from "./UiIcon.vue?vue&type=script&lang=js"
import style0 from "./UiIcon.vue?vue&type=style&index=0&id=3967a404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967a404",
  null
  
)

export default component.exports